function shouldDiscountProduct(productId, fullPricedCollection) {
  for (const element of fullPricedCollection) {
    if (element["id"] == productId) { return true; }
  }
  
  return false;
}

function getDiscountFromCookie() {
    const getCookieValue = (name) => (
      document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
    )

    const discountCode = getCookieValue("discount_code");

    if (discountCode == null || discountCode == 0){
    	return 0;
    }

    var percentToReturn = 0;

    jQuery.ajax({
        url: "https://nira-shopify-bucket.s3.amazonaws.com/discount_codes.json",
        dataType: "json",
        success: function(data) {
          if (data[discountCode] > 0) {
            percentToReturn = data[discountCode];
          }
        },
        async: false
    });

    return percentToReturn;
} 

function getStrikeThroughPriceFor(currentVariantPrice, productId) {
    var percentOff = getDiscountFromCookie();
    return getStrikeThroughPriceFromPriceAndDiscount(currentVariantPrice, percentOff, 2);
}

function getStrikeThroughPriceWithNoDecimalFor(currentVariantPrice, productId) {
    var percentOff = getDiscountFromCookie();
    return getStrikeThroughPriceFromPriceAndDiscount(currentVariantPrice, percentOff, 0);
}

function getStrikeThroughPriceFromPriceAndDiscount(currentVariantPrice, percentOff, decimalPlaces) {
    if (percentOff == null || percentOff == 0) { return null; }
    var price = currentVariantPrice * ((100 - percentOff) / 100);
    return getStrikeThroughForOriginalAndNewPrice(currentVariantPrice, price, decimalPlaces);
}

function getStrikeThroughForOriginalAndNewPrice(originalPrice, newPrice, decimalPlaces) {
    var priceAsDollars = (newPrice / 100).toFixed(decimalPlaces);
    var originalPriceAsDollars = (originalPrice / 100).toFixed(decimalPlaces);
    return "<s>$" + originalPriceAsDollars.toString() + "</s> <span class='custom-discounted-price'> $" + priceAsDollars.toString() + "<\span>";
}
      
function getDiscountedPriceFor(currentVariantPrice, productId) {
    var percentOff = getDiscountFromCookie();

    if (percentOff == null || percentOff == 0){
    	return null;
    }

    var price = currentVariantPrice * ((100 - percentOff) / 100);
    return (price / 100).toFixed(2);
}

document.addEventListener("smart-cart-hidden", function(element) {
  console.log("show smart hidden");
  document.body.classList.remove("slideout-right--open");
});

function waitForjQueryLazy(trigger) {
  var interval = setInterval(function () {
    if (window.jQuery !== undefined) {
      clearInterval(interval);
      trigger(window.jQuery);
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}



waitForjQueryLazy(function () {
  $(function() {
    $('.lazy').Lazy();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("variant") !== "subscribe") {
    document.querySelectorAll('.subscribe-page-only').forEach(section => {
      section.style = "display: none";
    });
  }
  
  if (urlParams.get("variant") === "subscribe") {
    document.querySelectorAll('.not-on-subscribe-page').forEach(section => {
      section.style = "display: none";
    });
  }
});

function waitForjQueryCustom(trigger) {
  var interval = setInterval(function () {
    if (window.jQuery !== undefined) {
      clearInterval(interval);
      trigger(window.jQuery);
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}

waitForjQueryCustom(function () {
  $(document).ready(function () {
    $(".price-test-add-to-cart").click(function () {

        console.log("gtag");
      
        gtag("event", "add_to_cart", {
          url: window.location.href
        });
    
        var value = $(".price-item--regular").html().replace("$", "");
        var floatValue = parseFloat(value);
    
        fbq("track", "AddToCart", {
          value: floatValue,
        });
      });
  });
});

